import descriptionSheetsService from '../../services/description-sheets'

export default {
  namespaced: true,
  state: {
    descriptionSheets: [],
    descriptionSheetDetails: undefined
  },
  mutations: {
    SET_DESCRIPTION_SHEETS(state, descriptionSheets) {
      state.descriptionSheets = descriptionSheets
    },
    SET_DESCRIPTION_SHEET_DETAILS(state, descriptionSheetDetails) {
      state.descriptionSheetDetails = descriptionSheetDetails
    }
  },
  actions: {
    refresh: async (context, params) => {
      const descriptionSheets = await descriptionSheetsService
        .getList(params)
        .catch(
          () => undefined
        )
      context.commit('SET_DESCRIPTION_SHEETS', descriptionSheets || [])
      return descriptionSheets
    },
    getDescriptionSheetById: async (context, id) => {
      const descriptionSheetDetails = await descriptionSheetsService
        .getDescriptionSheetById(id)
        .catch(
          () => undefined
        )
      context.commit('SET_DESCRIPTION_SHEET_DETAILS', descriptionSheetDetails || undefined)
      return descriptionSheetDetails
    }
  },
  getters: {
    descriptionSheets: state => state.descriptionSheets,
    descriptionSheetDetails: state => state.descriptionSheetDetails
  }
}
